import { CdkMenuModule } from '@angular/cdk/menu';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { GlobalModule } from '@app/core/global.module';
import { ButtonModule } from '@components/button/modules/button.module';
import { FuiCardComponent, FuiMenuComponent, FuiMenuItemComponent, FuiTooltipDirective } from '@fui/fui-components';
import { DynamicFieldsModule } from '../dynamic-fields/dynamic-fields.module';
import { OrganizeChipsDirective } from './directives/organize-chips.directive';
import { FormFilterFieldsComponent } from './form-filter-fields/form-filter-fields.component';
import { FormFilterComponent } from './form-filter.component';

@NgModule({
    declarations: [FormFilterComponent, FormFilterFieldsComponent, OrganizeChipsDirective],
    imports: [
        GlobalModule,
        DynamicFieldsModule,
        ButtonModule,
        MatChipsModule,
        CdkMenuModule,
        FuiCardComponent,
        FuiMenuComponent,
        FuiMenuItemComponent,
        FuiTooltipDirective,
    ],
    exports: [FormFilterComponent, FormFilterFieldsComponent],
})
export class FormFilterModule {}
